import React, { useState, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { connect } from 'react-redux';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { I18nPropvider } from './i18n';
import "./App.css";
import PrivateRoutes from './routes/PrivateRoutes';
import { actionChangeLanguage } from "./store/action/LayoutActionSupervisor";
import { firebaseObserver, userLogout } from "./components/common/FirebaseSupervisor";
import SignupSupervisor from "./components/SignupSupervisor";
import LayoutSupervisor from "./components/common/LayoutSupervisor";
import HomeSupervisor from "./components/HomeSupervisor";
import LoginSupervisor from "./components/LoginSupervisor";
import OTPSupervisor from "./components/OTPSupervisor";
import PasswordChange from "./components/PasswordChange";
import ExchangeRate from "./components/ExchangeRate";
import SupervisorList from "./components/SupervisorList";
import SupervisorAdd from "./components/SupervisorAdd";
import ClientList from "./components/ClientList";
import ClientModify from "./components/ClientModify";
import TrancheList from "./components/TrancheList";
import TrancheAdd from "./components/TrancheAdd";
import TrancheModify from "./components/TrancheModify";
import AgathaConfiguration from "./components/AgathaConfiguration";
import SupervisorLoginList from "./components/SupervisorLoginList";
import SupervisorActionLogList from "./components/SupervisorActionLogList";
import TransactionList from "./components/TransactionList";
import TransactionDetails from "./components/TransactionDetails";
import ExecutionList from "./components/ExecutionList";
import VfaspAccessRights from "./components/VfaspAccessRights";
import DefaultAccessRights from "./components/DefaultAccessRights";
import SupervisorAccessRights from "./components/SupervisorAccessRights";
import IssuerConfiguration from "./components/IssuerConfiguration";

const App = (props) => {
    const [authenticated, setAuthenticated] = useState(true);

    useEffect(() => {
        firebaseObserver.on('authStateChanged', data => {
            setAuthenticated(data);
        });
        return () => { firebaseObserver.off('authStateChanged'); }
    }, []);

    useEffect(() => {
        const locale = localStorage.getItem("locale");
        locale && props.actionChangeLanguage(localStorage.locale);
        const retVal = setTimeout(() => userLogout(2), 600000);
        localStorage.setItem("logouttimerid", retVal);
    }, []);

    return (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
            <I18nPropvider locale={props.locale}>
                <LayoutSupervisor>
                    <Routes>
                        <Route element={<PrivateRoutes auth={authenticated} />}>
                            <Route path="/" element={<HomeSupervisor />} />
                            <Route exact path="/dashboard" element={<HomeSupervisor />} />
                            <Route exact path="/supervisorotp" element={<OTPSupervisor />} />
                            <Route exact path="/passwordchange" element={<PasswordChange />} />
                            <Route exact path="/exchangerate" element={<ExchangeRate />} />
                            <Route exact path="/supervisorlist" element={<SupervisorList />} />
                            <Route exact path="/addsupervisor" element={<SupervisorAdd />} />
                            <Route exact path="/clientlist" element={<ClientList />} />
                            <Route exact path="/modifyclient" element={<ClientModify />} />
                            <Route exact path="/tranchelist" element={<TrancheList />} />
                            <Route exact path="/addtranche" element={<TrancheAdd />} />
                            <Route exact path="/modifytranche" element={<TrancheModify />} />
                            <Route exact path="/agathaconfig" element={<AgathaConfiguration />} />
                            <Route exact path="/supervisorloginlist" element={<SupervisorLoginList />} />
                            <Route exact path="/supervisoractionloglist" element={<SupervisorActionLogList />} />
                            <Route exact path="/transactionlist" element={<TransactionList />} />
                            <Route exact path="/transactiondetails" element={<TransactionDetails />} />
                            <Route exact path="/executionlist" element={<ExecutionList />} />
                            <Route exact path="/vfaspaccessrights" element={<VfaspAccessRights />} />
                            <Route exact path="/defaultaccessrights" element={<DefaultAccessRights />} />
                            <Route exact path="/supervisoraccessrights" element={<SupervisorAccessRights />} />
                            <Route exact path="/issuerconfig" element={<IssuerConfiguration />} />
                        </Route>
                        <Route exact path="/supervisorlogin" element={<LoginSupervisor />} />
                        <Route exact path="/signup" element={<SignupSupervisor />} />
                    </Routes>
                </LayoutSupervisor>
            </I18nPropvider>
        </LocalizationProvider >
    )
}

const mapStateToProps = state => {
    return {
        locale: state.siteLayout.locale,
    };
};

export default connect(mapStateToProps, { actionChangeLanguage })(App);